import { PriceInterface } from '../catalogs-model/price.interface';


export const enum OrderStatus {
    ORDER_RECEIVED = 'ORDER_RECEIVED',
    PAYMENT_WAITING = 'PAYMENT_WAITING',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
    PAYMENT_ACCEPTED = 'PAYMENT_ACCEPTED',
    ORDER_CANCELLED = 'ORDER_CANCELLED',
    ORDER_READY_TO_PICKING = 'ORDER_READY_TO_PICKING',
    ORDER_IN_PICKING = 'ORDER_IN_PICKING',
    ORDER_READY_TO_DELIVER = 'ORDER_READY_TO_DELIVER',
    ORDER_IN_DELIVERY = 'ORDER_IN_DELIVERY',
    ORDER_DELIVERED_TO_CUSTOMER = 'ORDER_DELIVERED_TO_CUSTOMER'
}

export class Order {

    private internalId: string;
    private creationDate: number;
    private centerName: string;
    private centerInternalId: string;
    private currentStatus: OrderStatus;
    private deviceName: string;
    private deviceInternalId: string;
    private app: string;
    private paymentType: string;
    private bankTransaction: string;
    private amount: PriceInterface;
    private nbArticles: number;
    private customerName: string;
    private customerPhone: string;
    private customerEmail: string;
    private urlTicketCustomer: string;
    private urlTicketStaff: string;

    constructor(internalId?: string, creationDate?: number, centerName?: string, centerInternalId?: string, currentStatus?: OrderStatus, deviceName?: string, deviceInternalId?: string, app?: string, paymentType?: string, bankTransaction?: string, amount?: PriceInterface, nbArticles?: number, customerName?: string, customerPhone?: string, customerEmail?: string, urlTicketCustomer?: string, urlTicketStaff?: string) {
        this.internalId = internalId;
        this.creationDate = creationDate;
        this.centerName = centerName;
        this.centerInternalId = centerInternalId;
        this.currentStatus = currentStatus;
        this.deviceName = deviceName;
        this.deviceInternalId = deviceInternalId;
        this.app = app;
        this.paymentType = paymentType;
        this.bankTransaction = bankTransaction;
        this.amount = amount;
        this.nbArticles = nbArticles;
        this.customerName = customerName;
        this.customerPhone = customerPhone;
        this.customerEmail = customerEmail;
        this.urlTicketCustomer = urlTicketCustomer;
        this.urlTicketStaff = urlTicketStaff;
    }

    public get InternalId(): string {
        return this.internalId;
    }
    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public get CreationDate(): number {
        return this.creationDate;
    }
    public set CreationDate(creationDate: number) {
        this.creationDate = creationDate;
    }
    public get CenterName(): string {
        return this.centerName;
    }
    public set CenterName(centerName: string) {
        this.centerName = centerName;
    }
    public get CenterInternalId(): string {
        return this.centerInternalId;
    }
    public set CenterInternalId(centerInternalId: string) {
        this.centerInternalId = centerInternalId;
    }
    public get CurrentStatus(): OrderStatus {
        return this.currentStatus;
    }
    public set CurrentStatus(currentStatus: OrderStatus) {
        this.currentStatus = currentStatus;
    }
    public get DeviceName(): string {
        return this.deviceName;
    }
    public set DeviceName(deviceName: string) {
        this.deviceName = deviceName;
    }
    public get DeviceInternalId(): string {
        return this.deviceInternalId;
    }
    public set DeviceInternalId(deviceInternalId: string) {
        this.deviceInternalId = deviceInternalId;
    }
    public get App(): string {
        return this.app;
    }
    public set App(app: string) {
        this.app = app;
    }
    public get PaymentType(): string {
        return this.paymentType;
    }
    public set PaymentType(paymentType: string) {
        this.paymentType = paymentType;
    }
    public get BankTransaction(): string {
        return this.bankTransaction;
    }
    public set BankTransaction(bankTransaction: string) {
        this.bankTransaction = bankTransaction;
    }
    public get Amount(): PriceInterface {
        return this.amount;
    }
    public set Amount(amount: PriceInterface) {
        this.amount = amount;
    }
    public get NbArticles(): number {
        return this.nbArticles;
    }
    public set NbArticles(nbArticles: number) {
        this.nbArticles = nbArticles;
    }
    public get CustomerName(): string {
        return this.customerName;
    }
    public set CustomerName(customerName: string) {
        this.customerName = customerName;
    }
    public get CustomerPhone(): string {
        return this.customerPhone;
    }
    public set CustomerPhone(customerPhone: string) {
        this.customerPhone = customerPhone;
    }
    public get CustomerEmail(): string {
        return this.customerEmail;
    }
    public set CustomerEmail(customerEmail: string) {
        this.customerEmail = customerEmail;
    }
    public get UrlTicketCustomer(): string {
        return this.urlTicketCustomer;
    }
    public set UrlTicketCustomer(urlTicketCustomer: string) {
        this.urlTicketCustomer = urlTicketCustomer;
    }
    public get UrlTicketStaff(): string {
        return this.urlTicketStaff;
    }
    public set UrlTicketStaff(urlTicketStaff: string) {
        this.urlTicketStaff = urlTicketStaff;
    }

}
